// extracted by mini-css-extract-plugin
export var planCard = "_t1-0";
export var planList = "_t1-1";